import classNames from 'classnames/bind';
import { useEffect } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  onReset: () => void;
  setMinFare?: React.Dispatch<React.SetStateAction<number | undefined>>;
}

export default function ResetFilter({ onReset, setMinFare }: IProps) {
  useEffect(() => {
    setMinFare?.(undefined);
  }, []);

  return (
    <div className={cx('ResetFilter')}>
      <h5 className={cx('title')}>선택된 상세조건에 맞는 항공편이 없습니다</h5>
      <p className={cx('txt')}>상세 조건을 다시 선택하세요</p>
      <button className={cx('confirm')} type="button" onClick={onReset}>
        상세조건 초기화
      </button>
    </div>
  );
}
